import {config} from '../../config';
import {TConfigGetterReturn} from '../types';
import {TDeviceGetFeatures} from './types';

const getSupportedDeviceFeatureByType = (deviceType: string) => {
    const supportedDeviceFeatures = config.data.promo?.tryFeature?.supportedDeviceFeatures as any;

    if (!supportedDeviceFeatures) return;

    return supportedDeviceFeatures[deviceType] || {};
};

export default {
    getIsTryFeatureEnabled: (): TConfigGetterReturn<boolean> => config.data.promo.tryFeature.isTryFeatureEnabled,
    getIsGetFeatureEnabled: (): TConfigGetterReturn<boolean> => config.data.promo?.getFeature?.isGetFeatureEnabled,
    getTryFeatureAvailabilityDays: (): TConfigGetterReturn<number> =>
        config.data.promo.tryFeature.tryFeatureAvailabilityDays,
    getIsCleaningModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isCleaningModeEnabled,
    getIsVibrateModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isVibrateModeEnabled,
    getIsResponsiveDrawModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isResponsiveDrawModeEnabled,
    getIsVapeCloudSizeModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isVapeCloudSizeModeEnabled,
    getIsLedModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isLedModeEnabled,
    getIsDeviceDiagnosticTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isConnectCareEnabled,
    getIsAutoStartModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isAutoStartModeEnabled,
    getIsGestureModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isGestureModeEnabled,
    getIsCountdownModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isCountdownModeEnabled,
    getIsVapeSessionTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isVapeSessionModeEnabled,
    getIsAdvancedDiagnosticModeTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isAdvancedDiagnosticModeEnabled,
    getIsAemTryFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isAemFlexBatteryEnabled,
    getIsFlexPuffTryFeatureFeatureEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getSupportedDeviceFeatureByType(deviceType).isFlexPuffEnabled,
    getDeviceGetFeatures: (deviceType: string): TConfigGetterReturn<TDeviceGetFeatures> => {
        const {supportedDeviceFeatures} = config.data.promo.getFeature || {};

        return supportedDeviceFeatures ? (supportedDeviceFeatures as any)[deviceType] : undefined;
    },
};
